import produce from 'immer';
import margeById from '../../helpers/margeById';

export const actions = {
  CREATE_TRAINING_CENTER: 'CREATE_TRAINING_CENTER',
  CREATE_TRAINING_CENTER_SUCCESS: 'CREATE_TRAINING_CENTER_SUCCESS',

  UPDATE_TRAINING_CENTER: 'UPDATE_TRAINING_CENTER',
  UPDATE_TRAINING_CENTER_SUCCESS: 'UPDATE_TRAINING_CENTER_SUCCESS',

  GET_TRAINING_CENTERS: 'GET_TRAINING_CENTERS',
  GET_TRAINING_CENTERS_SUCCESS: 'GET_TRAINING_CENTERS_SUCCESS',
  GET_SINGLE_TRAINING_CENTER: 'GET_SINGLE_TRAINING_CENTER',
  GET_SINGLE_TRAINING_CENTER_SUCCESS: 'GET_SINGLE_TRAINING_CENTER_SUCCESS',
	SET_TRAINING_CENTER_LOADING: 'SET_TRAINING_CENTER_LOADING',
  DELETE_TRAINING_CENTER: 'DELETE_TRAINING_CENTER',
  DELETE_TRAINING_CENTER_SUCCESS: 'DELETE_TRAINING_CENTER_SUCCESS',
  SWITCH_TRAINING_CENTER: 'SWITCH_TRAINING_CENTER' ,
  SWITCH_TRAINING_CENTER_SUCCESS: 'SWITCH_TRAINING_CENTER_SUCCESS',

  ADD_TRAINING_CENTER_COURSE: 'ADD_TRAINING_CENTER_COURSE',
ADD_TRAINING_CENTER_COURSE_SUCCESS: 'ADD_TRAINING_CENTER_COURSE_SUCCESS',

  EDIT_TRAINING_CENTER_COURSE: 'EDIT_TRAINING_CENTER_COURSE',

  EDIT_TRAINING_CENTER_COURSE_SUCCESS: 'EDIT_TRAINING_CENTER_COURSE_SUCCESS',


  DELETE_TRAINING_CENTER_COURSE: 'DELETE_TRAINING_CENTER_COURSE',
  DELETE_TRAINING_CENTER_COURSE_SUCCESS: 'DELETE_TRAINING_CENTER_COURSE_SUCCESS',

  SET_TRAINING_CENTER_COUNT: '	SET_TRAINING_CENTER_COUNT',
  
  SET_TRAINIG_CENTER_SEARCH_VALUE: 'SET_TRAINIG_CENTER_SEARCH_VALUE',
};

const initialState = {
  items: [],
  courses: [],
  isLoading: false,
  count: 0,
  searchValue: '',
  currentTrainigCenter: null
};
export default produce((draft, action) => {
  const { type, payload } = action;

  if (!draft) {
    return initialState;
  }

  switch (type) {
    // case actions.GET_SINGLE_TRAINING_CENTER_SUCCESS:
    case actions.CREATE_TRAINING_CENTER_SUCCESS: {
      const currentTrainingCenter = draft.items;

      const trainingCenter = payload;
      console.log(currentTrainingCenter, trainingCenter);
      draft.items = margeById(currentTrainingCenter, [payload]);
      break;
    }
    case actions.GET_TRAINING_CENTERS_SUCCESS: {
      const currentTrainingCenter = draft.items;
      draft.items = margeById(currentTrainingCenter, payload);
      draft.currentTrainigCenter = null
      break;
    }

    case actions.GET_SINGLE_TRAINING_CENTER_SUCCESS: {
      draft.currentTrainigCenter = payload;
      break;
    }

    case actions.DELETE_TRAINING_CENTER_SUCCESS: {
      draft.items = draft.items.filter((el) => el._id !== payload)
    }
    case actions.SWITCH_TRAINING_CENTER_SUCCESS:
    case actions.UPDATE_TRAINING_CENTER_SUCCESS: {
      const updatedTrainingCenter = payload;
      const targetIndex = draft.items.findIndex(
        (trainingCenter) => trainingCenter._id === updatedTrainingCenter._id
      );
      draft.items[targetIndex] = updatedTrainingCenter;
      break;
		}
		case actions.SET_TRAINING_CENTER_COUNT: {
			draft.count = payload
			break;
    }
    case actions.DELETE_TRAINING_CENTER_COURSE_SUCCESS: {
      draft.currentTrainigCenter.courses = draft.currentTrainigCenter.courses.filter((el) => el._id !== payload.courseId)
    }

    case actions.SET_TRAINING_CENTER_LOADING: {
      draft.isLoading = payload;
      break;
    }
    case actions.SET_TRAINIG_CENTER_SEARCH_VALUE: {
      draft.items = []
      draft.searchValue = payload
      break;
    }
  }
});

// const trainingCenterReducer = (state = initialState, action) => {
// 	switch (action.type) {
// 		case actions.GET_TRAINING_CENTERS:
// 			return [...state, action.payload];
// 		case actions.CREATE_TRAINING_CENTER:
// 			return action.payload;
// 		default:
// 			return state;
// 	}
// };
// export default trainingCenterReducer;
